import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'
import logo2 from '../../images/site_logo/site_logo_3.svg'
import MobileMenu from '../MobileMenu/MobileMenu'
import Services from '../../api/service'

const Header2 = (props) => {

    const [mobailActive, setMobailState] = useState(false);
    const location = useLocation();
    const serviceMenuColumns = [
        { title: 'Core IT Services', items: Services.slice(0, 4) },
        { title: 'Digital Solutions', items: Services.slice(4, 7) },
        { title: 'Advisory & Support', items: Services.slice(7, 10) },
    ];

    const closeOpenMenus = () => {
        setMobailState(false);

        if (typeof document !== 'undefined') {
            document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
                menu.classList.remove('show');
            });

            document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
                toggle.classList.remove('show');
                toggle.setAttribute('aria-expanded', 'false');
            });

            const collapseMenu = document.getElementById('main_menu_dropdown');
            if (collapseMenu) {
                collapseMenu.classList.remove('show');
            }
        }
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        closeOpenMenus();
    }

    const handleAnyNavLinkClick = (event) => {
        if (event.target.closest('a')) {
            ClickHandler();
        }
    };

    const isActivePath = (path, options = {}) => {
        if (options.exact) {
            return location.pathname === path;
        }
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    };

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        closeOpenMenus();
    }, [location.pathname]);


    return (

        <header className="site_header site_header_2">
            <div className={`header_bottom stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-3 col-lg-2 col-5">
                            <div className="site_logo">
                                <Link onClick={ClickHandler} className="site_link" to="/">
                                    <img src={logo2} alt="Site Logo – Krit – IT Solutions & Technology, Business Consultinge" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7 col-2">
                            <nav className="main_menu navbar navbar-expand-lg" onClickCapture={handleAnyNavLinkClick}>
                                <div className="main_menu_inner collapse navbar-collapse justify-content-lg-center" id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list justify-content-center">
                                        <li className={isActivePath('/', { exact: true }) ? 'active' : ''}>
                                            <Link onClick={ClickHandler} className="nav-link" to="/">
                                                Home
                                            </Link>
                                        </li>
                                           <li className={isActivePath('/about') ? 'active' : ''}><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                           <li className={isActivePath('/profile') ? 'active' : ''}><Link onClick={ClickHandler} to="/profile">Profile</Link></li>
                                        <li className={`dropdown ${location.pathname.startsWith('/service/') ? 'active' : ''}`}>
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="services_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                What we do
                                            </Link>
                                            <div className="dropdown-menu mega_menu_wrapper p-0" aria-labelledby="services_submenu">
                                                <div className="container">
                                                    <div className="row justify-content-lg-between">
                                                        <div className="col-lg-12">
                                                            <div className="row">
                                                                {serviceMenuColumns.map((column) => (
                                                                    <div className="col-lg-4" key={column.title}>
                                                                        <div className="megamenu_widget">
                                                                            <h3 className="megamenu_info_title">{column.title}</h3>
                                                                            <ul className="icon_list unordered_list_block">
                                                                                {column.items.map((service) => (
                                                                                    <li key={service.slug}>
                                                                                        <Link onClick={ClickHandler} to={`/service/${service.slug}`}>
                                                                                            <span className="icon_list_text service_menu_text">{service.title}</span>
                                                                                        </Link>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li className={isActivePath('/service', { exact: true }) ? 'active' : ''}><Link onClick={ClickHandler} to="/service">Solutions</Link></li>
                                        <li className={isActivePath('/contact') ? 'active' : ''}><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-5">
                            <ul className="header_btns_group unordered_list justify-content-end">
                                <li>
                                    <button className="mobile_menu_btn" onClick={() => setMobailState(!mobailActive)} type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} className="btn btn-primary" to="/contact">
                                        <span className="btn_label" data-text="Get Started">Get Started</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobail-wrap">
                    <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
                            <nav className="xb-header-nav">
                                <MobileMenu onNavigate={ClickHandler} />
                            </nav>
                        </div>
                    </div>
                    <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
                </div>
            </div>
        </header>

    )
}

export default Header2;
